<script>
import Swal from "sweetalert2";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { ref } from "vue";

import moment from 'moment';

import { useUserStore } from '@/store/user'
import socket from '@/services/socket'


/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const userStore = useUserStore();


    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      userStore,

    };
  },
  page: {
    title: "users",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Utilisateurs",
      items: [
        {
          text: "Définition",
        },
        {
          text: "Utilisateurs",
          active: true,
        },
      ],
      page: 1,
      perPage: 25,
      length: 0,
      users: [],
      users_search: [],
      search: "",
      status: 201,
    };
  },

  methods: {

    async loadFromStore() {
 
      if (!this.userStore.list) {
        await  this.userStore.loadFromApi(true).then(data => {
        this.users = data
          this.users_search = data;
        this.length =this.users.length;
     })
      } else {
        this.users = this.userStore.list
        this.users_search = this.users;
        this.length =this.users.length;
      }

      // Écoute temps réel
      socket.on('users.created', (data) => {
        this.userStore.addOne(data)
        this.users = this.userStore.list
        this.users_search = this.userStore.list;
        this.length = this.users.length;

      })

      socket.on('users.updated', (data) => {
        this.userStore.updateOne(data)
        this.users = this.userStore.list
        this.users_search = this.userStore.list
        this.length = this.users.length;
      })

    },

     async refresh() {

      await  this.userStore.loadFromApi(true).then(data => {
        this.users = data
        this.users_search = data;
        this.length =this.users.length;
     })

    },
   
    toggleStatus(user_id) {  this.userStore.toggleStatus(user_id); },
    
    toManager(user_id) {  this.userStore.toManager(user_id); },

    toAgent(user_id) {  this.userStore.toManager(user_id); },

    filter_user() {
      this.users = this.users_search;
      this.search = this.search?.trim() ?? '';
      if (this.search != "") {
        this.users = this.users.filter(          (user) =>
            user.lastName?.toLowerCase().includes(this.search.toLowerCase())
            || user.firstName?.toLowerCase().includes(this.search.toLowerCase())
            || user.email?.toLowerCase().includes(this.search.toLowerCase())
            || user.status?.toLowerCase().includes(this.search.toLowerCase())
            || user.country?.isoCode?.toLowerCase().includes(this.search.toLowerCase())
            || user.country?.name?.toLowerCase().includes(this.search.toLowerCase())
        );
        this.length = this.users.length;

      }
    },
    show(index) {
      return (
        index < this.page * this.perPage && index + 1 > (this.page - 1) * this.perPage
      );
    },
    next() {
      if (this.page * this.perPage < this.users.length) {
        this.page++;
      }
    },
    previous() {
      if (this.page >= 2) {
        this.page--;
      }
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          }
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
      
    },

    visibleColumns() {
      return this.tbHeader.filter(col => col.display);
    },

     convertDate(date) {
      return moment.utc(date).format('DD-MM-YY ') + " " + moment.utc(date).format(' HH:mm')
    },

    onView(user){
      this.userStore. setInfo(user);
    },
    lengthMinThan(value) {
      return value < length;
    },
  },
  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
     
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title d-flex justify-content-between align-items-center">Listes des Utilisateurs 
               <button @click="$router.back()" class="btn btn-secondary btn-sm mb-3 ">
                  Back
              </button>
            </h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>Utilisateurs</code>. 
            </p>

            <div class="row mb-4">
              <div class="col-md-3">
                <input
                  type="search"
                  class="form-control"
                  v-model="search"
                  v-on:input="filter_user()"
                  placeholder="Rechercher une personne"
                />
              </div>
              <div class="col-5 col-md-3 ms-0 ms-md-3 mt-2 mt-md-0">
                <select v-model="perPage" class="form-control text-center">
                 <option value="10"  >10 / {{length ?? 0}}</option>
                  <option value="25" >25 / {{length ?? 0}}</option>
                  <option value="50"  >50 / {{length ?? 0}}</option>
                  <option value="100" >100 / {{length ?? 0}} </option>
                  <option value="500" >500 / {{length ?? 0}}</option>
                </select>
              </div>

              <div class="ms-2 col-6 col-md-3  hstack text-end">
                <i
                  class="bx bx-left-arrow-alt p-2 fs-5"
                  type="button"
                  
                  @click="previous"
                ></i>

                <small class="ms-3">
                  {{ Math.ceil(users.length / perPage) > 0 ? page : 0 }} /
                  {{ Math.ceil(users.length / perPage) }}
                </small>

                <i
                  class="bx bx-right-arrow-alt fs-5 p-2 ms-3"
                  type="button"
                  @click="next"
                ></i>
              </div>

             
            </div>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr class="bg-light">
                    <th>#</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Sexe</th>
                    <th>Email</th>
                    <th>Ctry</th>
                    <th>Date Time</th>
                    <th class="text-center">Statut</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" v-show="show(index)" :key="user.id">
                    <th scope="row" v-on:click="compileToClipboard(user.id)" style="cursor: pointer;" >{{ index + 1 }}</th>
                    <td> <img
                        :src="user?.profile"
                        :alt="user.lastName"
                        style="height: 35px; width: 35px"
                        class="border rounded-circle"
                      />
                      {{ user.lastName  }}</td>
                    <td>{{ user.firstName }}</td>
                    <td>{{ user.gender == true ? "Masculin" : "Féminin" }}</td>
                    <td v-on:click="compileToClipboard(user.email)" style="cursor: pointer;">{{ user.email }}</td>
                    <td>{{ user.country?.isoCode }}</td>
                    <td>{{ convertDate(user.createdAt)  }}</td>
                    <td class="text-center">
                      <button
                        class="badge badge-pill badge-soft-success border-0 py-1 w-100"
                        v-if="user.status == 'active'" 
                       
                        v-on:click="toggleStatus(user.id)"
                        >
                         {{ user.status }}
                      </button>
                      <button
                        class="badge badge-pill badge-soft-danger border-0 py-1 w-100"
                        v-else
                        v-on:click="toggleStatus(user.id)" >
                        {{ user.status }}
                      </button>
                    </td>
                    <td class="hstack text-center ms-auto">
                      <div class="hstack">
                        <div class="dropdown">
                          <button
                            class="btn btn-secondary dropdown-toggle rounded-circle btn-sm"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="bx bx-dots-vertical-rounded fs-5"></i>
                          </button>
                          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li>
                              <button class="dropdown-item" @click="toManager(user.id)">
                                To Manager
                              </button>
                            </li>
                            <li>
                              <button class="dropdown-item" @click="toAgent(user.id)">
                                To Agent
                              </button>
                            </li>
                            <li>
                              <button
                                class="dropdown-item"
                                @click="toggleStatus(user.id)"
                              >
                                Bloquer
                              </button>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="'/users/' + user.id"
                                >Details</router-link
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <router-link :to="'/users/' + user.id" @click="onView(user)">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="users.length < 5" class="h-25"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-red-">Vous n'avez pas accès à cette page</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
